<div class="modal !z-[60]" [ngClass]="{'show':showModal}">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <div class="modal-title">Clear Cart</div>
                <div class="btn-close" [innerHTML]="icons.closeIcon" (click)="showModal = false"></div>
            </div>
            <div class="modal-body">
                <div class="modal-text">
                    {{modalType !== 'remove'?'Going back will reset your data. Do you want to continue?':'Removing ticket class will clear all items currently in your cart. Do you want to continue?'}}
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-border" (click)="close()">Cancel</button>
                <button type="button" class="btn btn-primary" (click)="goBack()">Yes</button>
            </div>
        </div>
    </div>
</div>
<div class="overlay !z-50" [ngClass]="{'show':showModal}"></div>
